<app-modal
  [title]="'DASHBOARD.SAVE_AS_TEMPLATE'"
  [saveButtonName]="'BUTTON.SAVE'"
  [cancelButtonName]="'DIALOG.BUTTONS.CANCEL'"
  (save)="onSave()"
  [isDataLoaded]="!!data"
  [shouldSaveBeDisabled]="!isValid()"
>
  <ng-container body>
    <mat-dialog-content>
      <app-emu-input
        data-cy="template-input-name"
        [name]="'INPUT.NAME'"
        [validator]="isValid.bind(this)"
        placeholder="{{ 'DASHBOARD.TEMPLATE_NAME' | translate }}"
        [(value)]="dashboard.name"
      >
      </app-emu-input>
    </mat-dialog-content>
  </ng-container>
</app-modal>
